import React from 'react';
import { Helmet } from 'react-helmet';
const HotjarTag = () => {
  return <Helmet data-id="element-1808">
      {/* Hotjar Tracking Code */}
      <script src="https://t.contentsquare.net/uxa/1a3107defdcc7.js" data-id="element-1809"></script>
    </Helmet>;
};
export default HotjarTag;